<template>
  <div>
    <div class="d-flex align-center justify-space-between mb-2">
      <h4 class="mb-0">Avaliações</h4>
      <div v-if="loading" class="d-flex flex-column align-center gap-2">
        <v-skeleton-loader type="image" width="130" height="22" />
        <v-skeleton-loader type="image" width="70" height="14" />
      </div>
      <div v-else class="d-flex flex-column align-center">
        <v-rating
          :value="aggregate?._avg?.value || 0"
          readonly
          dense
          background-color="primary"
        />
        <small class="ml-2">
          {{ aggregate?._count || 0 }} avaliação{{
            aggregate?._count == 1 ? "" : "s"
          }}
        </small>
      </div>
    </div>
    <v-alert v-if="error" type="error" text>
      {{ error }}
    </v-alert>

    <div v-else class="d-flex flex-column gap-2">
      <v-card
        v-for="rating in ratingsComments"
        :key="rating.id"
        class="pa-3"
        outlined
      >
        <v-rating
          class="float-right"
          :value="rating.value"
          readonly
          small
          dense
          background-color="primary"
        />
        <b v-if="rating.Party" class="mb-0">{{ rating.Party.name }}</b>
        <p class="mb-0">
          {{ rating.comment }}
        </p>
      </v-card>
      <template v-if="loading">
        <v-skeleton-loader
          v-for="i in 10"
          :key="i"
          type="image"
          width="100%"
          :height="50 + Math.random() * 100"
        />
      </template>
    </div>
    <v-btn
      v-if="aggregate?._count > ratings.length"
      block
      color="primary"
      class="mt-2"
      @click="getRatings"
    >
      Carregar mais
    </v-btn>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import organization from "@/services/admin/organization";
export default {
  data() {
    return {
      loading: false,
      ratings: [],
      aggregate: {},
      error: null,
    };
  },
  methods: {
    async getRatings() {
      try {
        this.loading = true;
        this.error = null;

        const response = await organization.getRatings(
          this.selectedOrganization.id,
          {
            skip: this.ratings.length,
          }
        );
        this.ratings = [
          ...this.ratings,
          ...response.ratings.map((r) => ({
            ...r,
            Party: this.partiesMap[r.partyId],
          })),
        ];
        if (response.aggregate) this.aggregate = response.aggregate;
      } catch (error) {
        this.error = error.message || "Erro ao carregar avaliações";
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    ...mapGetters("organization", ["selectedOrganization", "parties"]),
    partiesMap() {
      return this.parties.reduce((acc, party) => {
        acc[party.id] = party;
        return acc;
      }, {});
    },
    ratingsComments() {
      return this.ratings.filter((r) => !!r.comment);
    },
  },
  mounted() {
    this.getRatings();
  },
};
</script>
